import Modal from '../../../../../../shared/Modal'
import TextField from '../../../../../../shared/Forms/TextField'
import { useState } from 'react'
import { ILevel } from '../../../../../../types/tasks.types'
import { useRecoilState } from 'recoil'
import sandboxAtom from '../../../../../Sandbox/sandbox.atom'
import NumberInput from '../../../../../../shared/Inputs/NumberInput'
import Textarea from '../../../../../../shared/Inputs/Textarea'
import TextInput from '../../../../../../shared/Inputs/TextInput'
import Button from '../../../../../../shared/Buttons/Button'
import useHttpLoader from '../../../../../../hooks/useHttpLoader'
import levelsService from '../../../../../../services/levels.service'
import arrayUtils from '../../../../../../utils/array.utils'

interface IProps {
  onClose: () => void
}
const CreateLevelModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [sandboxState, setSandboxState] = useRecoilState(sandboxAtom)
  const [draft, setDraft] = useState<Omit<ILevel, 'created' | 'updated'>>({
    id: '',
    description: '',
    name: '',
    orderingIndex: 0,
    pack: sandboxState.version.id,
  })

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(levelsService.create(draft), (resp) => {
      if (resp.status === 'success') {
        setSandboxState((prev) => ({
          ...prev,
          levels: arrayUtils.addItemToTop({ items: prev.levels }, resp.body).items,
        }))
        props.onClose()
      }
    })
  }

  return (
    <Modal onClose={props.onClose}>
      <div className="flex-form">
        <h2 style={{ marginBottom: '1em', fontSize: 28 }}>Создание уровня</h2>
        <TextField header="ID">
          <TextInput value={draft.id} name="id" onChange={handleChange} placeHolder="ID (For devs only)" />
        </TextField>
        <TextField header="Ordering index">
          <NumberInput value={draft.orderingIndex} onChange={handleChange} name="orderingIndex" />
        </TextField>
        <TextField header="Название">
          <TextInput value={draft.name} name="name" onChange={handleChange} placeHolder="Чтение по слогам" />
        </TextField>
        <TextField header="Описание">
          <Textarea
            value={draft.description}
            name="description"
            onChange={handleChange}
            placeHolder="Чтение по слогам"
          />
        </TextField>
      </div>
      <div className="form-footer">
        <Button onClick={handleSave} loading={loading}>
          Сохранить
        </Button>
        <Button onClick={props.onClose}>Отмена</Button>
      </div>
    </Modal>
  )
}

export default CreateLevelModal
